import { styled } from '@uhg-abyss/web/tools/styled';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';

export const LocationSearchWrapper = styled('div', {
  borderRadius: '36px',
  overflow: 'hidden',
  maxWidth: '90%',
  position: 'absolute',

  variants: {
    isLocationModal: {
      true: {
        top: '100px',
        width: '400px',
        '@media (max-width: 464px)': {
          top: '115px',
        },
      },
      false: {
        width: '750px',
      },
    },
    isHighlighted: {
      true: {
        border: '2px solid #196ECF',
      },
      false: {
        border: '1px solid #CBCCCD',
      },
    },
  },

  defaultVariants: {
    isLocationModal: false,
    isHighlighted: false,
  },
});

export const LocationSearchSpacer = styled('div', {
  position: 'relative',
  height: '62px',
  visibility: 'hidden',
});

export const LocationModal = styled(ModalDialog, {
  '.abyss-modal-base-header-container': {
    padding: '16px',
  },
  '.abyss-modal-base-body': {
    rowGap: '8px',
  },
});

// Styles applied directly to <p>, not under `.abyss-text-root`, since this is a plain element (not Abyss Text) and would otherwise lose centering (regression from PR #18267).
export const MessagingText = styled('p', {
  maxWidth: '940px',
  textAlign: 'center',
  fontStyle: 'normal',
  fontWeight: '400',
});

export const LocationInputContainer = styled(Flex, {
  flexWrap: 'nowrap',
  alignItems: 'center',
  height: '60px',
  backgroundColor: '#FFFFFF',
  padding: '8px 24px',
  justifyContent: 'space-between',
  '@media (max-width: 744px)': {
    minWidth: '320px',
  },
  '@media (max-width: 464px)': {
    width: '100%',
    minWidth: '100px',
    paddingRight: '10px',
    paddingLeft: '16px',
    '.abyss-search-input-root': {
      minWidth: '150px',
    },
    button: {
      padding: '10px 16px',
    },
  },
  '.abyss-search-input-root': {
    height: '38px',
  },
  '.abyss-search-input-input': {
    height: '38px',
    background: 'transparent',
    paddingRight: '35px',
  },
  '#location-search-input-area': {
    flexGrow: 1,
    marginRight: '24px',
  },

  variants: {
    isLocationModal: {
      true: {
        maxWidth: '400px',
        minWidth: 'auto',
        paddingRight: '0px',
        height: '58px',
        '.abyss-search-input-input': {
          height: '24px',
          minHeight: '24px',
        },
      },
    },
    isLocationModalInFocus: {
      true: {
        borderColor: '$core.color.brand.60',
        borderBottom: '0px',
        borderTopLeftRadius: '32px',
        borderTopRightRadius: '32px',
        borderBottomLeftRadius: '0px',
        borderBottomRightRadius: '0px',
      },
    },
  },
});
